
// Copyright (c) 2021 Siemens

/**
 * @module js/DesCommonService
 */

/**
 * This function update n number of view model data property
 *
 * @param {*} viewModel
 * @param {*} VariablesToUpdate
 */
export const updateVmoVariables = (viewModel, VariablesToUpdate) => {
    const { data, dispatch } = viewModel;
    for (const property in VariablesToUpdate) {
        data[property] = VariablesToUpdate[property];
    }
    dispatch({ path: 'data', value: { ...data } });
};



const exports = {
    updateVmoVariables
};

export default exports;
